import { mapGetters } from 'vuex'
import constants from '@/dependencies/constants'

export default {
  computed: {
    ...mapGetters({
      domain: 'location/getDomainLang'
    }),
    isNativeDomain() {
      return this.domain === constants.DOMAIN.UA
    }
  }
}
